import { Injectable, inject } from '@angular/core';
import { TimeFormat, UserSettings } from 'models/user-settings';
import { providerConfig } from '../../../providerconfig';
import { TranslateService } from '@ngx-translate/core';
import { ColorScheme, ThemeService } from 'services/theme.service';

export const LANGUAGE_STORAGE_KEY = 'LANGUAGE';
const TIME_FORMAT_STORAGE_KEY = 'TIME_FORMAT';
const COLOR_SCHEME_STORAGE_KEY = 'COLOR_SCHEME';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {
  private translate = inject(TranslateService);
  private themeService = inject(ThemeService);

  public getUserSettings(): UserSettings {
    const language = this.getLanguage();
    const timeFormat = <TimeFormat>localStorage.getItem(TIME_FORMAT_STORAGE_KEY) || TimeFormat._24h;
    const colorScheme =
      <ColorScheme>localStorage.getItem(COLOR_SCHEME_STORAGE_KEY) || ColorScheme.LIGHT;
    return new UserSettings(language, timeFormat, colorScheme);
  }

  public saveUserSettings(settings: Partial<UserSettings>): void {
    if (settings.language) {
      this.setLanguage(settings.language);
    }

    if (settings.timeFormat) {
      localStorage.setItem(TIME_FORMAT_STORAGE_KEY, settings.timeFormat);
    }

    if (settings.colorScheme) {
      this.themeService.updateColorScheme(settings.colorScheme);
      localStorage.setItem(COLOR_SCHEME_STORAGE_KEY, settings.colorScheme);
    }
  }

  private setLanguage(language: string): void {
    if (!language || !providerConfig.languages.includes(language)) {
      return;
    }

    this.translate.setDefaultLang(language);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }

  private getLanguage(): string {
    const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);

    if (storedLanguage && providerConfig.languages.includes(storedLanguage)) {
      return storedLanguage;
    }

    return providerConfig.defaultLanguage;
  }
}
